import type { media as mediaEn } from "../en/media";

export const media: typeof mediaEn = {
  folders: {
    destinations: "Destinace",
    trips: "Zájezdy",
    activities: "Inspirace",
    guides: "Průvodci",
    blog: "Blog",
    teams: "Týmy",
    general: "Obecné",
    departurePhotos: "Fotky z termínů",
  },
  page: {
    title: "Knihovna médií",
    subtitle: "Správa všech obrázků",
    findDuplicates: "Najít duplikáty",
    trashEmpty: "Koš je prázdný",
    noMedia: "Žádná média",
    emptyFiltered: "Žádná fotka neodpovídá filtrům",
    clearFilters: "Zrušit filtry",
    loadErrorShort: "Nepodařilo se načíst média.",
    total_one: "{{formatted}} fotka",
    total_few: "{{formatted}} fotky",
    total_other: "{{formatted}} fotek",
    selectLoaded: "Vybrat vše načtené",
    select: "Vybrat {{name}}",
    starred: "Dobrá fotka",
    usageCount_one: "Použito: {{count}}",
    usageCount_few: "Použito: {{count}}",
    usageCount_other: "Použito: {{count}}",
    liveTwin: "Živá fotka",
    liveTwinTitle: "V knihovně je živá fotka se stejným obsahem",
  },
  filters: {
    label: "Filtry",
    search: "Hledat alt, tagy, název souboru, titulek…",
    countryNone: "Bez země",
    countryClear: "Všechny země",
    starred: "★ Dobré fotky",
    sourceAll: "Všechny zdroje",
    orientationAll: "Všechny orientace",
    orientationLandscape: "Na šířku",
    orientationPortrait: "Na výšku",
    orientationSquare: "Čtverec",
    usageAll: "Vše",
    usageUsed: "Použité",
    usageUnused: "Nepoužité",
    folderAll: "Všechny druhy",
    trash: "Koš",
  },
  actions: {
    restore: "Obnovit",
    hardDelete: "Smazat trvale",
  },
  albums: {
    title: "Alba",
    allImages: "Všechny obrázky",
    newAlbum: "Nové album",
    newSubAlbum: "Nové podalbum",
    rename: "Přejmenovat",
    deleteAlbum: "Smazat album",
    confirmDelete: "Smazat album „{{name}}“? Obrázky smazány nebudou.",
    expand: "Rozbalit",
    collapse: "Sbalit",
    addToAlbum: "Přidat do alba",
    addToAlbumMenu: "Přidat do alba…",
    addCountTitle_one: "Přidat {{count}} obrázek do alba",
    addCountTitle_few: "Přidat {{count}} obrázky do alba",
    addCountTitle_other: "Přidat {{count}} obrázků do alba",
  },
  move: {
    title_one: "Přesunout {{count}} položku",
    title_few: "Přesunout {{count}} položky",
    title_other: "Přesunout {{count}} položek",
    action: "Přesunout",
  },
  merge: {
    title: "Sloučit duplicitní obrázky",
    apply_one: "Sloučit {{count}} duplikát",
    apply_few: "Sloučit {{count}} duplikáty",
    apply_other: "Sloučit {{count}} duplikátů",
    noneFound:
      "Žádné přesné duplikáty nenalezeny. (Duplikáty se detekují podle obsahového hashe SHA-256 — pokud hashe chybí, spusťte nejdříve content backfill.)",
    foundGroups_one: "Nalezena {{count}} skupina duplikátů",
    foundGroups_few: "Nalezeny {{count}} skupiny duplikátů",
    foundGroups_other: "Nalezeno {{count}} skupin duplikátů",
    willDelete_one: "{{count}} obrázek bude přesunut do koše",
    willDelete_few: "{{count}} obrázky budou přesunuty do koše",
    willDelete_other: "{{count}} obrázků bude přesunuto do koše",
    willRepoint_one: "{{count}} odkaz bude přesměrován na kanonický obrázek",
    willRepoint_few: "{{count}} odkazy budou přesměrovány na kanonický obrázek",
    willRepoint_other: "{{count}} odkazů bude přesměrováno na kanonický obrázek",
    keep: "Ponechat: {{name}}",
    removing_one: "Odstraní se {{count}} duplikát: {{ids}}",
    removing_few: "Odstraní se {{count}} duplikáty: {{ids}}",
    removing_other: "Odstraní se {{count}} duplikátů: {{ids}}",
    progress_one: "Sloučeno {{done}} z {{count}} skupiny",
    progress_few: "Sloučeno {{done}} z {{count}} skupin",
    progress_other: "Sloučeno {{done}} z {{count}} skupin",
    finished: "Hotovo. Seznam knihovny se obnoví po zavření.",
    failed_one:
      "Sloučení se zastavilo po {{done}} z {{count}} skupiny. Další dávky se neposlaly, sloučené zůstávají.",
    failed_few:
      "Sloučení se zastavilo po {{done}} z {{count}} skupin. Další dávky se neposlaly, sloučené zůstávají.",
    failed_other:
      "Sloučení se zastavilo po {{done}} z {{count}} skupin. Další dávky se neposlaly, sloučené zůstávají.",
    previewFailed: "Náhled duplicit se nepodařilo načíst.",
  },
  focal: {
    dragHint: "Tažením nastavte ohnisko. X {{x}}, Y {{y}}",
    resetAuto: "Zpět na automatický",
  },
  // Stav ohniska v detailu fotky (auto = střed, ai = hlavní motiv podle AI, manual = ruční).
  focalState: {
    auto: "Automatické",
    ai: "AI",
    manual: "Ruční",
  },
  // Náhledy ploch webu, na kterých se fotka ořezává (pořadí = FOCAL_SURFACE_IDS).
  focalPreviews: {
    title: "Náhled ploch",
    sampleHeading: "Nadpis přes fotku",
    heroMobile: "Hero mobil",
    heroDesktop: "Hero desktop",
    card16x10: "Karta 16:10",
    card3x4: "Karta 3:4",
    square: "Čtverec",
  },
  drawer: {
    title: "Detail média",
    altLabel: "Alt text (povinný)",
    altPlaceholder: "Popište obrázek pro SEO a přístupnost",
    altRequired: "Alt text je povinný.",
    titlePlaceholder: "Volitelný titulek",
    descriptionPlaceholder: "Delší popis — zlepšuje vyhledávání podle klíčových slov",
    tags: "Tagy",
    tagPlaceholder: "Přidejte tag a stiskněte Enter",
    focalPoint: "Ohnisko",
    publicUrl: "Veřejná URL",
    copyUrl: "Kopírovat URL",
    dimensions: "Rozměry",
    size: "Velikost",
    format: "Formát",
    uploaded: "Nahráno",
    uploadedBy: "Nahrál(a)",
    usedIn: "Použito v",
    notReferenced: "Není použito v žádné entitě.",
    inAlbums: "V albech",
    notInAlbum: "Není v žádném albu.",
    removeFromAlbum: "Odebrat z alba {{name}}",
    exactDuplicates: "Přesné duplikáty",
    original: "Originál",
    confirmTrash: "Přesunout tento obrázek do koše?",
    confirmHardDelete: "Trvale smazat tento obrázek? Tuto akci nelze vrátit.",
  },
  editor: {
    bold: "Tučně (Ctrl+B)",
    italic: "Kurzíva (Ctrl+I)",
    strikethrough: "Přeškrtnutí",
    heading1: "Nadpis 1",
    heading2: "Nadpis 2",
    bulletList: "Odrážkový seznam",
    numberedList: "Číslovaný seznam",
    quote: "Citace",
    codeBlock: "Blok kódu",
    moment: "Go2 Moment",
    insertImage: "Vložit obrázek",
    insertYoutube: "Vložit YouTube video",
    horizontalRule: "Vodorovná čára",
    undo: "Zpět (Ctrl+Z)",
    redo: "Znovu (Ctrl+Y)",
    startTyping: "Začněte psát…",
    linkUrlPrompt: "URL odkazu:",
    momentSelectFirst: "Nejdříve vyberte text, který chcete označit jako Go2 Moment.",
    momentPrompt: "Go2 Moment — popis:",
    momentPromptExisting: "Go2 Moment — popis (prázdný pro odebrání):",
    youtubeVideo: "YouTube video",
    videoThumbAlt: "Náhled videa",
    noUrlSet: "URL není nastavena",
    youtubeUrlPrompt: "YouTube URL:",
    youtubeUrlPromptExample: "YouTube URL (např. https://www.youtube.com/watch?v=...):",
    changeUrl: "Změnit URL",
    setUrl: "Nastavit URL",
    openVideo: "Otevřít video",
    imageNotFound: "Obrázek nenalezen",
  },
};
